<form
  *ngIf="form && initialized"
  [formGroup]="form"
  (ngSubmit)="submit()"
  class="p-fluid">
  <app-header icon="fas fa-palette" text="Farben"></app-header>
  <div class="grid">
    <app-colorset-dropdown
      [colSize]="5"
      [fallback]="defaultsService.generalFallback()"
      formControlName="colorset"></app-colorset-dropdown>
  </div>

  <p-divider />

  <app-header icon="fas fa-a" text="Beschriftung"></app-header>
  <div class="grid">
    <app-form-field-wrapper
      [hideLabel]="true"
      [floatingLabel]="false"
      [name]="'displayValues'"
      [colSize]="6">
      <p-checkbox
        [binary]="true"
        label="Werte einblenden"
        name="displayValues"
        formControlName="displayValues"></p-checkbox>
    </app-form-field-wrapper>
  </div>
</form>
